import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import memoizeOne from "memoize-one";
import selectors from "../selectors/lion-selectors";

var LionTranslate = function (_PureComponent) {
  _inherits(LionTranslate, _PureComponent);

  function LionTranslate() {
    var _temp, _this, _ret;

    _classCallCheck(this, LionTranslate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.renderInline = function () {
      return React.createElement("span", {
        "data-qa": _this.props.lionkey,
        dangerouslySetInnerHTML: {
          __html: _this.props.translatedString
        }
      });
    }, _this.renderBlock = function () {
      var targetString = _this.props.translatedString;
      var firstBullet = targetString.indexOf("•");
      var preamble = void 0;
      var list = void 0;
      if (firstBullet >= 0) {
        preamble = targetString.substr(0, firstBullet);
        list = targetString.substr(firstBullet + 1).split("•");
      } else {
        preamble = targetString;
        list = null;
      }

      return React.createElement(
        "div",
        { "data-qa": _this.props.lionkey },
        preamble,
        list && React.createElement(
          "ul",
          null,
          list.map(function (item, index) {
            return React.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: item } });
          })
        )
      );
    }, _this.render = function () {
      return _this.props.blockFormat ? _this.renderBlock() : _this.renderInline();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LionTranslate;
}(PureComponent);

LionTranslate.propTypes = {
  // lionkey: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
  blockFormat: PropTypes.bool,
  placeholders: PropTypes.string,
  values: PropTypes.string,
  replacements: PropTypes.objectOf(PropTypes.string)
};

LionTranslate.defaultProps = {
  blockFormat: false
};

var getReplacements = memoizeOne(function (replacements, placeholders, values) {
  if (replacements) {
    // new api
    return replacements;
  }

  if (placeholders && values) {
    var valArray = values.split(",");
    return placeholders.split(",").reduce(function (acc, curr, idx) {
      acc[curr] = valArray[idx];
      return acc;
    }, {});
  }

  return null;
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var replacements = getReplacements(ownProps.replacements, ownProps.placeholders, ownProps.values);
  return {
    translatedString: selectors.getLionTranslatedStringWithFallback(state, ownProps.lionkey, ownProps.fallback, replacements)
  };
};

var LionTranslateContainer = connect(mapStateToProps)(LionTranslate);

export { LionTranslate };
export default LionTranslateContainer;